import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { catchError, tap, throwError } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { Injectable } from "@angular/core";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private toastrService: ToastrService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
		return next.handle(request)
		.pipe(
			catchError((response: HttpErrorResponse) => {
				this.toastrService.error(response.error.message, 'Erreur');
				return throwError(response);
			})
		)
	}
}
